import React from 'react';
import styles from './region-entity-table.module.scss';

export const InfoNotice = ({ entityOrRegion }) => {
    return (
        <div>
            <p className={`${styles.cellInfoText} ${styles.tableInfoText}`}>** Includes locations where education is delivered by third party providers</p>
            {(entityOrRegion.name.includes('TAFE') || entityOrRegion.name.includes("Department of Employment")) &&
                <p className={`${styles.cellInfoText} ${styles.tableInfoText}`}>
                    Department of Employment, Small Business and Training campuses are {entityOrRegion.name.includes('TAFE') && "also "}provided for use by TAFE Queensland under a memorandum of understanding.
                    TAFE Queensland also uses additional locations for vocational education and training, outside of those provided by the department.
                </p>
            }
            {
                entityOrRegion.name.includes("Griffith") &&
                <p className={`${styles.cellInfoText} ${styles.tableInfoText}`}>*** No FTEs have been apportioned to online delivery</p>

            }
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/region-entity-table/info-notice.js